import PropTypes from 'prop-types'
import { Grid, Cell } from 'baseui/layout-grid'
import CommonFallback from '@/shared/components/CommonFallback'
import DashboardFilters from './DashboardFilters/DashboardFilters'
import DashboardTable from './DashboardTable/DashboardTable'
import DashboardPreviewer from './DashboardPreviewer/DashboardPreviewer'
import useDashboard from './useDashboard'
import DashboardPaginator from './DashboardTable/DashboardPaginator'
import { Card } from '@/shared/theme/styled-components'

const Dashboard = ({ type }) => {
  const { isLoading, getSubscriptions, filters, usersList, providersList, applicationType, t, navigateToV2 } =
    useDashboard({ type })

  if (isLoading) {
    return <CommonFallback />
  }

  return (
    <Grid>
      <Cell span={12}>
        <div
          style={{
            marginBottom: '2rem',
            backgroundColor: 'white',
            padding: '1rem',
            borderRadius: '1rem',
            boxShadow: '0 2px 6px rgba(20,96,170,.3)',
            textDecoration: 'underline',
          }}
        >
          <a onClick={navigateToV2}>{t('subscriptionTable:link_to_v2_text')}</a>
        </div>
      </Cell>
      <Cell span={12}>
        <DashboardFilters
          applicationType={applicationType}
          type={type}
          filters={filters}
          usersList={usersList}
          providersList={providersList}
        />
      </Cell>
      <Cell span={9}>
        <Card>
          <DashboardTable />
          <DashboardPaginator />
        </Card>
      </Cell>
      <Cell span={3}>
        <DashboardPreviewer updateTable={getSubscriptions} />
      </Cell>
    </Grid>
  )
}

Dashboard.propTypes = {
  type: PropTypes.string,
}

export default Dashboard
